module.exports = __webpack_public_path__ + "img/csgs.e3940e7f.png";